module.exports = __webpack_public_path__ + "img/1361x768-oscuro.020ce4b7.jpg";